module.exports = __webpack_public_path__ + "img/GasbotSideTopRobot.edecb123.webp";